import { createContext, useState } from 'react';

export interface AuthStateType {
  token: string;
  setToken: (token: string) => void;
}

const initialAuthState: AuthStateType = {
  token: localStorage.getItem('id_token') || '',
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setToken: () => {},
};

export const AuthContext = createContext<AuthStateType>(initialAuthState);

export default function AuthProvider({ children }: any) {
  const [token, setToken] = useState(localStorage.getItem('id_token') || '');

  return (
    <AuthContext.Provider
      value={{
        token,
        setToken,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}
